// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1PPTy","paramInput":"JobSimulator_paramInput__2TjpF","input":"JobSimulator_input__2CxVR"};